import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';

const styles = theme => ({
    root: {
        marginTop: theme.spacing(2),
        color: theme.palette.grey[500]
    },
});

const Footer = (props) => {
    let {classes} = props;

    return (
        <Typography className={classes.root} variant="body2" align="left">
            Freight Legend
            {' '}
            <Link underline="always" color="inherit" href="https://www.nauticashipping.com/terms" target="_blank">
                Terms and Conditions
            </Link>
        </Typography>
    )
};
  

export default withStyles(styles)(Footer);
